import {Realm} from "../environment/realm/realm";

export function $Float64ArrayPrototype$(realm: Realm) {
	return realm["[[GlobalObject]]"].Float64Array.prototype;
}
